import React from 'react';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import { size } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { SUB_MENU_TYPES } from 'components/header/navigation-bar/mobile-menu/index';
import { displaySettingsSelector, helpMenuSelector } from 'common/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

export const LanguageMenuItem = ({ showHideSubMenu }) => {
  const { t } = useTranslation();

  return (
    <li>
      <button
        className="ct-mobile-menu__list-elem ct-mobile-menu__button"
        onClick={() => showHideSubMenu(SUB_MENU_TYPES.LANGUAGES)}
        tabIndex={0}
        data-e2e="mobile-nav-item-language"
      >
        {t('language')} ({t(i18next.language)})
        <FontAwesomeIcon icon={faAngleRight} aria-hidden="true" />
      </button>
    </li>
  );
};

export const HelpMenuItem = ({ showHideSubMenu }) => {
  const { t } = useTranslation();

  return (
    <li>
      <button
        className="ct-mobile-menu__list-elem ct-mobile-menu__button"
        onClick={() => showHideSubMenu(SUB_MENU_TYPES.HELP)}
        tabIndex={0}
      >
        {t('help')}
        <FontAwesomeIcon icon={faAngleRight} aria-hidden="true" />
      </button>
    </li>
  );
};

export const SubMenuFragment = ({ showHideSubMenu }) => {
  const helpMenu = useSelector(helpMenuSelector);
  const { languages } = useSelector(displaySettingsSelector);

  const hasLngMenu = size(languages) > 1;
  const hasHelpMenu = size(helpMenu) > 0;

  return hasLngMenu || hasHelpMenu ? (
    <ul className="ct-mobile-menu__list">
      {hasLngMenu && <LanguageMenuItem showHideSubMenu={showHideSubMenu} />}
      {hasHelpMenu && <HelpMenuItem showHideSubMenu={showHideSubMenu} />}
    </ul>
  ) : null;
};
